import { callKarrotBridgeSafely } from '../lib/karrot_bridge_utils'
import { readSessionJson, removeSessionItem, writeSessionJson } from '../lib/session_storage'

const FLOW_STACK_KEY = 'csFlowStack'

// 플로우 스택을 업데이트하고 현재 depth 반환
function updateFlowStack() {
  const currentPath = window.location.pathname

  // feedbacks 플로우가 아니면 스택 초기화
  if (!currentPath.startsWith('/wv/feedbacks')) {
    removeSessionItem(FLOW_STACK_KEY)
    return 0
  }

  let stack = readSessionJson(FLOW_STACK_KEY, [])

  // 현재 페이지가 스택에 있으면 그 위치까지 pop (뒤로가기로 온 경우)
  const existingIndex = stack.indexOf(currentPath)
  if (existingIndex !== -1) {
    stack = stack.slice(0, existingIndex + 1)
  } else {
    // 새 페이지면 push
    stack.push(currentPath)
  }

  writeSessionJson(FLOW_STACK_KEY, stack)

  // depth 반환 (0이면 첫 페이지)
  return stack.length - 1
}

// feedbacks 플로우에서 첫 페이지가 아니면 백스와이프 비활성화
const shouldDisableBackSwipe = () => {
  const depth = updateFlowStack()
  return depth > 0
}

callKarrotBridgeSafely((bridge) => {
  bridge.styleCurrentRouter({
    router: {
      navbar: false,
      backSwipable: !shouldDisableBackSwipe()
    }
  })
})
